import styled from 'styled-components';
const VisuallyHiddenDiv = styled.span(({ theme: { screenReader } }) => screenReader.srOnlyInline);
export { VisuallyHiddenDiv };
//# sourceMappingURL=shared.js.map